import React, { useEffect, useRef, useState } from "react";

const CustomMultiSelect = ({
  options = [],
  selectedValues = [], // Array of objects [{ label, value }, ...]
  onChange,
  placeholder = "Sélectionnez les options",
  className = "",
  icon,
}) => {
  // console.log({selectedValues})

  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  // Toggle dropdown
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle option selection/deselection
  const handleOptionClick = (option) => {
    const isSelected = selectedValues.some(
      (selected) => selected === option
    );
    // console.log({isSelected})
    const updatedValues = isSelected
      ? selectedValues.filter((selected) => selected !== option)
      : [...selectedValues, option];
      // console.log({updatedValues})
    onChange(updatedValues);
  };

  return (
    <div className={`custom-select-wrapper w-full`} ref={selectRef}>
      <div
        className={`custom-select flex items-center border rounded p-2 cursor-pointer ${className}`}
        onClick={toggleDropdown}
        aria-expanded={isOpen}
        role="combobox"
      >
        {icon && <span className="mr-2">{icon}</span>}
        <span className="flex-1">
          {selectedValues.length > 0
            ? `${selectedValues.length} moyen(s) sélectionné(s)`
            : placeholder}
        </span>
        {!icon && <span className="select-icon"></span>}
      </div>

      {isOpen && (
        <div className="custom-options absolute z-10 bg-white border rounded mt-1 w-full max-h-60 overflow-y-auto">
          {options.map((option) => (
            <div
              key={option.value}
              className={`custom-option p-2 cursor-pointer hover:bg-gray-100 ${
                selectedValues.some((selected) => selected === option.value)
                  ? "bg-gray-200"
                  : ""
              }`}
              onClick={() => handleOptionClick(option.value)}
              role="option"
              aria-selected={selectedValues.some(
                (selected) => selected === option.value
              )}
            >
              {option.label}
              {selectedValues.some(
                (selected) => selected === option.value
              ) && <span className="checkmark ml-8">✔</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomMultiSelect;